var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJetChevronIconContentDefault = function SvgJetChevronIconContentDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242E30",
    d: "M1.73.566 9.5 8.598 17.296.5l1.444 1.313-8.046 8.347a1.746 1.746 0 0 1-2.454 0L.313 1.918z"
  })));
};
export { SvgJetChevronIconContentDefault as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxOSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNzMgMC41NjU2MjVMOS41IDguNTk4MTNMMTcuMjk2MiAwLjVMMTguNzQgMS44MTI1TDEwLjY5NDQgMTAuMTZDMTAuMzY3NiAxMC40ODMgOS45MjY2NiAxMC42NjQyIDkuNDY3MTkgMTAuNjY0MkM5LjAwNzcxIDEwLjY2NDIgOC41NjY3NyAxMC40ODMgOC4yNCAxMC4xNkwwLjMxMjUgMS45MTc1TDEuNzMgMC41NjU2MjVaIiBmaWxsPSIjMjQyRTMwIi8+Cjwvc3ZnPgo=";